<template>
    <section class="font-poppins">
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen">
                <div class="flex justify-between p-2 pt-5 md:flex-col-reverse">
                    <div class="md:mt-3">
                        <GetDate/>
                        <div class="flex">
                            <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ADMIN</p>
                            <router-link to="/create-admin" class="p-2 text-white ml-3 rounded" style="background-color:#0048AE">ADD ADMIN</router-link>
                        </div>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>

                <div>
                    <AdminList/>
                </div>
            </div>
             
        </div>

       
    </section>
</template>

<script>
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminList from './AdminList.vue';
export default {
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        AdminList
    }
}
</script>